import { render } from "./RequestForQuotation.vue?vue&type=template&id=4c78c0c3&scoped=true"
import script from "./RequestForQuotation.vue?vue&type=script&lang=js"
export * from "./RequestForQuotation.vue?vue&type=script&lang=js"

import "./RequestForQuotation.vue?vue&type=style&index=0&id=4c78c0c3&scoped=true&lang=css"
import "./RequestForQuotation.vue?vue&type=style&index=1&id=4c78c0c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c78c0c3"]])

export default __exports__